import { createViewContext } from "../../../Components/createViewContext"
import { ISettingsType, Settings, type ISettings, type IShip, type IShipUser } from "../../../Types"

export interface SelectedShipData {
  shipId?: number;
  ship?: IShip;
  shipUser?: IShipUser;
  shipUsers?: readonly IShipUser[];
  activeShipUserId?: number;
  bundleLoaded: boolean;
  reset: () => void;
}

const selectedShipContext = createViewContext<SelectedShipData>();

export const SelectedShipContext = selectedShipContext.Context;
export const useSelectedShip = selectedShipContext.useGet;

export function withSelectedShipSettings(
  ship: IShip,
  settings: readonly ISettings[] | undefined,
): IShip {
  const result = { ...ship };
  const shipSettings = settings?.find((row) => row.settingType == ISettingsType.ship);
  if (shipSettings) {
    const parsed = Settings.parse(shipSettings);
    if (parsed.settingType == ISettingsType.ship) {
      result.shipSettings = parsed.dataParsed;
    }
  }
  const shipData = settings?.find((row) => row.settingType == ISettingsType.shipData);
  if (shipData) {
    const parsed = Settings.parse(shipData);
    if (parsed.settingType == ISettingsType.shipData) {
      result.shipData = parsed.dataParsed;
    }
  }
  return result;
}
